import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import Header from "../../../Header";
import pako from "pako";
import * as actionFunction from "../../../actions/common";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
// import "./customer.css";
import Pagination from "react-js-pagination";

import { BsFilter } from "react-icons/bs";
import { BsSearch } from "react-icons/bs";
import { BiX } from "react-icons/bi";
import { RxMixerHorizontal } from "react-icons/rx";
import useTableheading from "../hooks/useTableheading";
import useFetchGet from "../hooks/useFetchGet";
import useFetchPost from "../hooks/useFetchPost";
import TableHead from "../table/TableHead";
import TableList from "../table/TableList";

import CheckPicker from "rsuite/CheckPicker";
import Button from "rsuite/Button";
import RsuiteChecker from "../RsuiteChecker";
import DateRangePicker from "rsuite/DateRangePicker";
import DatePicker from "rsuite/DatePicker";
import Dropdown from "rsuite/Dropdown";
import IconButton from "rsuite/IconButton";
import CheckboxGroup from "rsuite/CheckboxGroup";
import Checkbox from "rsuite/Checkbox";
import Input from "rsuite/Input";
import InputGroup from "rsuite/InputGroup";
import Loader from "rsuite/Loader";
import Avatar from "rsuite/Avatar";
import SelectPicker from "rsuite/SelectPicker";
import TagPicker from "rsuite/TagPicker";
import TagPickerValueRenderer from "../TagPickerValueRenderer";
import TagPickerImageValueRenderer from "../TagPickerImageValueRenderer";
import { BiSearchAlt2 } from "react-icons/bi";
import { getCookie } from "./Utility";

// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import "rsuite/CheckPicker/styles/index.css";
// import "rsuite/dist/rsuite.min.css";
import "../../../assets/css/rsuite.css";
import $ from "jquery";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SearchIcon } from "@rsuite/icons/Search";
import { addDays } from "date-fns";
import moment from "moment";

import { useParams, withRouter, useLocation } from "react-router-dom";
import { DataTable } from "react-data-table-component";

/* customer Map Start */
import Drawer from "rsuite/Drawer";
import Highcharts from "highcharts";
/* customer Map End */

/* Lead acccount */
import ReactModal from 'react-modal';
import CreateTrialForm from "./CreateTrialForm";
/* Lead acccount */

import { jsx } from "@emotion/react";

const predefinedRanges = [
	{
		label: "Today",
		value: [new Date(), new Date()],
		placement: "left",
	},
	{
		label: "Yesterday",
		value: [addDays(new Date(), -1), addDays(new Date(), -1)],
		placement: "left",
	},
	{
		label: "Last 7 Days",
		value: [addDays(new Date(), -7), new Date()],
		placement: "left",
	},
	{
		label: "Last 30 Days",
		value: [addDays(new Date(), -30), new Date()],
		placement: "left",
	},
];

const footerStyles = {
	padding: "2px 5px",
	display: "flex",
	justifyContent: "space-between" /* To push buttons to left and right */,
	alignItems: "center",
	width: "100%" /* Ensure container takes full width */,
};

const footerButtonStyle = {
	float: "right",
	marginRight: 10,
	marginTop: 2,
};
const footerButtonStyleRight = {
	float: "right",
	marginRight: 0,
	marginTop: "-4px",
};

const renderIconButton = (props, ref) => {
	return <IconButton {...props} ref={ref} icon={<RxMixerHorizontal />} style={{ background: "#fff" }} />;
};
function delay(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}
const NewCustomerList = ({ history }) => {
	const location = useLocation();
	const [customerLists, setCustomerLists] = useState([]);
	const [loading, setLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(
		(history.location && history.location.state && history.location.state.pageNumber) || 1
	);
	const [perPage, setperPage] = useState(20);
	const [totalCount, setTotalCount] = useState(0);
	const [offSet, setoffSet] = useState(0);
	const [order, setOrder] = useState("desc");
	const [sort, setSort] = useState("created_date");
	const [search, setSearch] = useState("");
	const [searchTemp, setSearchTemp] = useState("");
	const [filterItem, setFilterItem] = useState({});
	const [highlightedColumns, setHighlightedColumns] = useState({});
	const [localStorageProcessed, setLocalStorageProcessed] = useState(false); // Flag to track localStorage completion
	const [quickfilterTotal, setQuickfilterTotal] = useState({
		all: 0,
		customer: 0,
		lead: 0,
		demo: 0,
		cancelled: 0,
		deleted: 0,
	});
	const [crmSearchFieldLists, setCrmSearchFieldLists] = useState([]);
	const [crmUserFilterKeyLists, setCrmUserFilterKeyLists] = useState([]);
	const [apiRun, setApiRun] = useState(false);
	const [resetCounter, setResetCounter] = useState(0);

	const [showFilter, setShowFilter] = useState(false);

	const [acManager, setAcManager] = useState([]);
	const [tseOwner, setTseOwner] = useState([]);
	const [slManager, setSlManager] = useState([]);
	const [filterColumn, setFilterColumn] = useState("");
	const [filterValue, setFilterValue] = useState("");
	const [filterTempValue, setFilterTempValue] = useState("");
	const [filterTempDateValue, setFilterTempDateValue] = useState("");

	const [quickFilterColor, setQuickFilterColor] = useState(true);

	const { fetchData } = useFetchGet();
	const { fetchPostData } = useFetchPost();
	const [usersData, setUsersData] = useState({});
	const [productData, setProductData] = useState([]);
	const [productOptions, setProductOptions] = useState([]);
	const [customerTypeData, setCustomerTypeData] = useState([]);
	const [packageData, setPackageData] = useState([]);
	const [countryData, setCountryData] = useState([]);
	const [applicationData, setApplicationData] = useState([]);
	const [sourceData, setSourceData] = useState([]);
	const [cancelReasonData, setCancelReasonData] = useState([]);
	const [accountManagerData, setAccountManagerData] = useState([]);
	const [salesManagerData, setSalesManagerData] = useState([]);
	const [tseOwnerData, setTseOwnerData] = useState([]);
	const [tattleColumnData, setTattleColumnData] = useState([]);
	//states for async loading
	const [isProductLoading, setIsProductLoading] = useState(false);
	const [isCustomerLoading, setIsCustomerLoading] = useState(false);
	const [isPackageLoading, setIsPackageLoading] = useState(false);
	const [isCountryLoading, setIsCountryLoading] = useState(false);
	const [isApplicationLoading, setIsApplicationLoading] = useState(false);
	const [isSourceLoading, setIsSourceLoading] = useState(false);
	const [isCanceLoading, setIsCancelLoading] = useState(false);
	const [isAccountManagerLoading, setIsAccountManagerLoading] = useState(false);
	const [isSalesManagerLoading, setIsSalesManagerLoading] = useState(false);
	const [isTseOwnerLoading, setIsTseOwnerManagerLoading] = useState(false);
	const [isColumnLoading, setIsColumnLoading] = useState(false);

	const [moreButton, setMoreButton] = useState(true);
	const [moreFilter, setMoreFilter] = useState(false);
	const [isDateFilter, setIsDateFilter] = useState(false);
	const [inputDateList, setInputDateList] = useState([]);

	const [inputValue, setInputValue] = useState({});
	const [inputTemp, setInputTemp] = useState({});

	// Column hide & show
	const [isOpen, setIsOpen] = useState(false);
	const [selectedColumnValues, setSelectedColumnValues] = useState([]);
	const [previousSelectedColumns, setPreviousSelectedColumns] = useState([]);
	const [searchQuery, setSearchQuery] = useState("");
	const [reloadTattleList, setReloadTattleList] = useState(0);
	//Muvi user id to return login url
	const [muviUserId, setMuviUserId] = useState(0);

	/* customer Map Start */
	const [openWithHeader, setOpenWithHeader] = useState(false);
	/* customer Map End */


	//Localstorage
	const crmFilter = {};

	// Parse query parameters for url encrypt and dcrypt
	const searchParams = new URLSearchParams(location.search);
	const queryString = searchParams.get("debug");
	const debug = queryString == null || queryString == "false" ? false : true;

	const queryStringType = searchParams.get("type");
	const queryStringCountryCode = searchParams.get("country_code");
	const queryStringStartDate = searchParams.get("start_date");
	const queryStringEndDate = searchParams.get("end_date");

	// free trial pop up
	const [modalOpen, setModalOpen] = useState(false);
	const firstCustomerRef = useRef(null);
	const [emailModalOpen, setEmailModalOpen] = useState(false);
	const [apiUrl, setApiUrl] = useState("");
	const [formData, setFormData] = useState({
		customerName: "",
		companyName: "",
		phoneNumber: "",
		emailId: "",
		password: "",
		products: [],
	});
	const [appToken, setAppToken] = useState("");

	const [testCredentialModalOpen, setTestCredentialModalOpen] = useState(false);
	const [testCredentials, setTestCredentials] = useState({
		email: "",
		password: "",
	});
	const [copied, setCopied] = useState(false);

	const [copiedData, setCopiedData] = useState(""); // To store copied data
	const [isBlurred, setIsBlurred] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (copied) {
				setCopied(false);
				setIsBlurred(false); // Reset the blur when the tick disappears
			}
		}, 1000); // Reset after 1 second
		return () => clearTimeout(timeout);
	}, [copied]);

	const fetchTestCredentials = async () => {
		try {
			const apiUrl = `${process.env.REACT_APP_CRM}/crm/get-test-credentials`;
			const response = await fetch(apiUrl, { method: "GET" });

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const data = await response.json();
			console.log("Fetched Data:", data);

			if (data.code === 200 && data.data) {
				setTestCredentials({
					email: data.data.email || "",
					password: data.data.password || "",
				});
			} else {
				console.warn(
					"No credentials found or an error occurred:",
					data.message
				);
				setTestCredentials({ email: "", password: "" });
			}
		} catch (error) {
			console.error("Failed to fetch test credentials:", error.message);
		}
	};

	const handleTestCredentialClick = async () => {
		await fetchTestCredentials();
		setTestCredentialModalOpen(true);
	};

	const handleCopy = () => {
		// Copy both email and password to clipboard
		const textToCopy = `Email: ${testCredentials.email}\nPassword: ${testCredentials.password}`;
		navigator.clipboard.writeText(textToCopy).then(() => {
			setCopied(true);
			setCopiedData(textToCopy); // Store the copied data
			setIsBlurred(true);
		});
	};

	function decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	function decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}

	//Declare array for dynamic filter for UserMongo and ProductMongo
	let crmUserFilterDateArr = ["created_date", "created_on"];
	// Define a callback function to receive data from child component
	const receiveDataFromChild = (dataFromChild, shortVal, orderVal) => {
		setOrder(orderVal);
		setSort(shortVal);
		// Update state with data received from child component
		//check object is empty or not
		if (Object.keys(dataFromChild).length >= 1) {
			setHighlightedColumns((prevInputValue) => ({
				...prevInputValue,
				...dataFromChild, // Update inputValue with the selected values
			}));
		}
	};

	const tableData = useTableheading(reloadTattleList);
	const columnsData = tableData && tableData ? tableData.columns : [];
	// const hiddenColumnsData = tableData && tableData ? tableData.hidden_columns : [];
	//const usersData =  tableData && tableData.users ? tableData.users : [];
	useEffect(() => {
		if (tableData && Array.isArray(tableData.columns)) {
			const activeColumnList = columnsData.map((item) => ({
				...item,
				isSelected: true,
			}));

			//const searchColumnList = [...activeColumnList, ...inactiveColumnList];
			const filteredOptions = tattleColumnData.filter((option) =>
				option.headerName.toLowerCase().includes(searchQuery.toLowerCase())
			);
			setCrmSearchFieldLists(filteredOptions);

			const selectedColumn = activeColumnList
				.filter((item) => item.isSelected === true)
				.map((item) => item.field);
			setSelectedColumnValues(selectedColumn);
			setPreviousSelectedColumns(selectedColumn);
			// Filter for columns with 'attribute_type' as 'date' and map to 'field' values
			const dateAttributes = tattleColumnData
				.filter((item) => item.attribute_type === "date")
				.map((item) => item.field);
			setInputDateList(dateAttributes);
		}
	}, [tableData, tattleColumnData, searchQuery]);

	const getUsers = async () => {
		try {
			//DLOa1fdPDY9LN7RYOIyBhMKb161NCSSq
			const responseData = await fetchData(
				process.env.REACT_APP_tattle_api + "/users?app_token=" + process.env.REACT_APP_tattle_token
			);
			setUsersData(responseData);
		} catch (error) {
			console.error("Error:", error);
		}
	};
	//get quick filter count data
	const getQuickFilterDataCount = () => {
		fetch(`${process.env.REACT_APP_CRM}/crm/statistics`)
			.then((res) => {
				if (!res.ok) {
					console.error(`HTTP error! Status: ${res.status}`);
					//throw new Error(`HTTP error! Status: ${res.status}`);
				}
				return res.json();
			})
			.then((data) => {
				if (data && data.code === 200 && data.data) {
					setQuickfilterTotal({
						all: data.data.TOTAL_ALL,
						customer: data.data.TOTAL_CUSTOMER,
						lead: data.data.TOTAL_LEAD,
						demo: data.data.TOTAL_DEMO,
						cancelled: data.data.TOTAL_CANCELLED,
						deleted: data.data.TOTAL_DELETED,
					});
				} else {
					console.error("API error! Response data:", data);
				}
			})
			.catch((error) => {
				console.error("Fetch error:", error); // Log any fetch errors
			});
	};

	// Convert the provided object into an array  is_active
	const userDataArray = Object.values(usersData || {});

	function removeEmptyValues(obj) {
		for (let key in obj) {
			if (obj.hasOwnProperty(key) && (obj[key] === "" || (Array.isArray(obj[key]) && obj[key].length === 0))) {
				delete obj[key];
			}
		}
		return obj;
	}

	const getCustomerData = async (current_page) => {
		const requestBody = {
			per_page: perPage,
			current_page: search !== "" ? 1 : current_page,
			order,
			sort,
			debug,
		};

		// Add the search parameter to the request body if it's not null
		if (search !== "") {
			requestBody.search = search;
		}

		// Check filter objects not empty
		let myObject = removeEmptyValues(highlightedColumns);
		// Create an empty object to store the filtered data
		let crmUserFilteredData = {};
		let crmUserFilteredDateeRangeData = {};
		let filteredData = {};

		if (Object.keys(myObject).length >= 1) {
			for (const key in myObject) {
				if (myObject.hasOwnProperty(key)) {
					if (crmUserFilterKeyLists.includes(key)) {
						// Add the key-value pair to crmUserFilteredData
						crmUserFilteredData[key] = myObject[key];
					} else if (crmUserFilterDateArr.includes(key)) {
						let dateArray = myObject[key].split(" ~ ").map((date) => date.trim());
						crmUserFilteredDateeRangeData[key] = dateArray;
					} else {
						filteredData[key] = myObject[key];
					}
				}
			}
		}

		// Check Advanced filter objects not empty
		let myObject2 = removeEmptyValues(inputValue);
		if (Object.keys(myObject2).length >= 1) {
			for (const key in myObject2) {
				if (myObject2.hasOwnProperty(key)) {
					if (crmUserFilterKeyLists.includes(key)) {
						// Add the key-value pair to crmUserFilteredData
						crmUserFilteredData[key] = myObject2[key];
					} else if (crmUserFilterDateArr.includes(key)) {
						let dateArray = myObject2[key].split(" ~ ").map((date) => date.trim());
						crmUserFilteredDateeRangeData[key] = dateArray;
					} else {
						filteredData[key] = myObject2[key];
					}
				}
			}
		}

		if (filterColumn && filterValue.length >= 1) {
			if (crmUserFilterKeyLists.includes(filterColumn)) {
				crmUserFilteredData[filterColumn] = filterValue;
			} else {
				// check filtercolumn is date type make it a array
				if (inputDateList.includes(filterColumn)) {
					//let dateArray = filterValue.split(" ~ ").map((date) => date.trim());
					crmUserFilteredDateeRangeData[filterColumn] = filterValue;
				} else {
					filteredData[filterColumn] = filterValue;
				}
			}
		}
		// Initialize requestBody.filter if it's not already initialized
		requestBody.filter = requestBody.filter || {};

		// Initialize requestBody.filter.crm_user if it's not already initialized
		requestBody.filter.crm_user = requestBody.filter.crm_user || {};

		// Initialize requestBody.filter.crm_user if it's not already initialized
		requestBody.filter.crm_product = requestBody.filter.crm_product || {};

		// Add the filtered data to requestBody if there is any matched data
		if (Object.keys(crmUserFilteredData).length > 0) {
			requestBody.filter.crm_user = {
				...requestBody.filter.crm_user,
				...crmUserFilteredData,
			};
		}

		if (Object.keys(crmUserFilteredDateeRangeData).length > 0) {
			requestBody.filter.crm_product = {
				...requestBody.filter.crm_product,
				range: crmUserFilteredDateeRangeData,
			};
		}

		if (Object.keys(filteredData).length > 0) {
			requestBody.filter.crm_product = {
				...requestBody.filter.crm_product,
				...filteredData,
			};
		}

		if (
			(acManager && acManager.length >= 1) ||
			(tseOwner && tseOwner.length >= 1) ||
			(slManager && slManager.length >= 1)
		) {
			// Update requestBody.filter.crm_user only with non-empty arrays
			requestBody.filter.crm_user = {
				...requestBody.filter.crm_user,
				...(acManager && acManager.length > 0 ? { account_manager: acManager } : {}),
				...(tseOwner && tseOwner.length > 0 ? { tse_owner: tseOwner } : {}),
				...(slManager && slManager.length > 0 ? { sales_manager: slManager } : {}),
			};
		}

		if (
			queryStringType != null &&
			queryStringType.length >= 1 &&
			queryStringCountryCode != null &&
			queryStringCountryCode.length >= 1 &&
			queryStringStartDate != null &&
			queryStringStartDate.length >= 1 &&
			queryStringEndDate != null &&
			queryStringEndDate.length >= 1
		) {
			requestBody.filter.crm_user = {
				...requestBody.filter.crm_user,
				country_code: queryStringCountryCode,
			};
			const newStartDate = queryStringStartDate + "-01";
			const [year, month] = queryStringEndDate.split("-").map(Number);
			const daysInMonth = new Date(year, month, 0).getDate();
			const newEndDate = queryStringEndDate + "-" + daysInMonth;
			requestBody.filter.crm_product = {
				...requestBody.filter.crm_product,
				customer_type: queryStringType,
				range: {
					first_subscription_date: [newStartDate, newEndDate],
				},
			};
			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				country_code: [queryStringCountryCode],
				customer_type: [queryStringType],
			}));
			//setShowFilter(!showFilter);
		}

		// Remove empty crm_user and filter objects if they are empty
		if (requestBody.filter.crm_user && Object.keys(requestBody.filter.crm_user).length === 0) {
			delete requestBody.filter.crm_user;
		}

		if (Object.keys(requestBody.filter.crm_product).length === 0) {
			delete requestBody.filter.crm_product;
		}
		console.log("Request Data", requestBody.filter);

		try {
			const responseData = await fetchPostData(`${process.env.REACT_APP_CRM}/crm/list`, requestBody, debug);
			//console.log(responseData);

			if (responseData && responseData.code == 200) {
				setLoading(false);
				setCustomerLists(responseData.data || []);
				setTotalCount(responseData.total_count);
				setoffSet(responseData.offset);
				setperPage(responseData.per_page);
				setApiRun(false);
			} else {
				setLoading(false);
				setCustomerLists([]);
				setTotalCount(0);
				setApiRun(false);
			}
		} catch (error) {
			console.error("Error:", error);
		}
		/*
		fetch(`${process.env.REACT_APP_CRM}/crm/list`, {
			method: "POST",
			body: JSON.stringify(requestBody),
		})
			.then((res) => {
				if (!res.ok) {
					throw new Error(`HTTP error! Status: ${res.status}`);
				}
				return res.json();
			})
			.then((data) => {
				if (data.code == 200) {
					setLoading(false);
					setCustomerLists(data.data || []);
					setTotalCount(data.total_count);
					setoffSet(data.offset);
					setperPage(data.per_page);
					setApiRun(false);
					//const missingKeys = findMissingKeys(data.data);
					//console.log("Missing keys:", missingKeys);
				} else {
					throw new Error(`API error! Code: ${data.code}`);
				}
			})
			.catch((error) => {
				console.error("Fetch error:", error.message);
				// Handle fetch error
			});
		*/
	};

	function handlePageChange(pageNumber = 1) {
		setCurrentPage(pageNumber);
		getCustomerData(pageNumber);
	}
	const getCrmFilterKeys = async () => {
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/user-filter-list`);
			if (responseData.code == 200) {
				let crmUserFilterArr = responseData.data.map((item) => item.user_fields);
				setCrmUserFilterKeyLists(crmUserFilterArr);
			} else {
				setCrmUserFilterKeyLists([
					"name",
					"email",
					"company_name",
					"source",
					"phone_number",
					"domain_name",
					"lead_source",
					"country_name",
					"country_code",
				]);
			}
		} catch (error) {
			console.error("Error:", error);
		}
	};
	const getProduct = async () => {
		setIsProductLoading(true);
		try {
			const responseProductData = await fetchData(`${process.env.REACT_APP_CRM}/crm/product/list`);
			setProductData(responseProductData);
			setProductOptions(responseProductData
				.filter((item) => !item.product_name.includes('Classic') && !item.product_name.includes('Ads') && !item.product_name.includes('CRM')
				).map((item, index) => ({
					label: item.product_name,
					value: item.product_key,
					data: item,
					id: `${index + 1}`
				})));
			setIsProductLoading(false);
		} catch (error) {
			setIsProductLoading(false);
			console.error("Error:", error);
		}
	};
	const getCustomerType = async () => {
		setIsCustomerLoading(true);
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_tattle_api}/get-customerType`);
			const convertedData = Object.keys(responseData).map((key) => ({
				id: key,
				value: responseData[key].customer_type,
			}));

			setCustomerTypeData(convertedData);
			setIsCustomerLoading(false);
		} catch (error) {
			setIsCustomerLoading(false);
			console.error("Error:", error);
		}
	};
	const getPackage = async () => {
		setIsPackageLoading(true);
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/package-list`);
			if (responseData.code == 200) {
				setPackageData(responseData.data);
				setIsPackageLoading(false);
			} else {
				setPackageData([]);
				setIsPackageLoading(false);
			}
		} catch (error) {
			setIsPackageLoading(false);
			console.error("Error:", error);
		}
	};
	const getCountries = async () => {
		setIsCountryLoading(true);
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/country-list`);
			if (responseData.code == 200) {
				setCountryData(responseData.data);
				setIsCountryLoading(false);
			} else {
				setCountryData([]);
				setIsCountryLoading(false);
			}
		} catch (error) {
			setIsCountryLoading(false);
			console.error("Error:", error);
		}
	};
	const getApplication = async () => {
		setIsApplicationLoading(true);
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/application-list`);
			if (responseData.code == 200) {
				setApplicationData(responseData.data);
				setIsApplicationLoading(false);
			} else {
				setApplicationData([]);
				setIsApplicationLoading(false);
			}
		} catch (error) {
			setIsApplicationLoading(false);
			console.error("Error:", error);
		}
	};
	const getSource = async () => {
		setIsSourceLoading(true);
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/source-list`);
			if (responseData.code == 200) {
				setSourceData(responseData.data);
				setIsSourceLoading(false);
			} else {
				setSourceData([]);
				setIsSourceLoading(false);
			}
		} catch (error) {
			setIsSourceLoading(false);
			console.error("Error:", error);
		}
	};
	const getCrmSearchField = async () => {
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/crm-search-field-list`);
			if (responseData.code == 200) {
				const dateAttributes = responseData.data
					.filter((item) => item.attribute_type === "date")
					.map((item) => item.value);
				setInputDateList(dateAttributes);
				setCrmSearchFieldLists(responseData.data);
			} else {
				setCrmSearchFieldLists([]);
			}
		} catch (error) {
			console.error("Error:", error);
		}
	};
	const getCancelReason = async () => {
		setIsCancelLoading(true);
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/cancel-reason-list`);
			if (responseData.code == 200) {
				setCancelReasonData(responseData.data);
				setIsCancelLoading(false);
			} else {
				setCancelReasonData([]);
				setIsCancelLoading(false);
			}
		} catch (error) {
			setIsCancelLoading(false);
			console.error("Error:", error);
		}
	};
	const getAccountManager = async () => {
		setIsAccountManagerLoading(true);
		try {
			const responseData = await fetchData(
				`${decryptconfigdata("apiUrl")}/tattle/GetGroupMembers?email=accountmanagement@muvi.com`
			);
			if (responseData.code == 200) {
				setAccountManagerData(responseData.data);
				setIsAccountManagerLoading(false);
			} else {
				setAccountManagerData([]);
				setIsAccountManagerLoading(false);
			}
		} catch (error) {
			setIsAccountManagerLoading(false);
			console.error("Error:", error);
		}
	};
	const getSalesManager = async () => {
		setIsSalesManagerLoading(true);
		try {
			const responseData = await fetchData(
				`${decryptconfigdata("apiUrl")}/tattle/GetGroupMembers?email=sales@muvi.com`
			);
			if (responseData.code == 200) {
				setSalesManagerData(responseData.data);
				setIsSalesManagerLoading(false);
			} else {
				setSalesManagerData([]);
				setIsSalesManagerLoading(false);
			}
		} catch (error) {
			setIsSalesManagerLoading(false);
			console.error("Error:", error);
		}
	};
	const getTseOwnerManager = async () => {
		setIsTseOwnerManagerLoading(true);
		try {
			const responseData = await fetchData(
				`${decryptconfigdata("apiUrl")}/tattle/GetGroupMembers?email=support@muvi.com`
			);
			if (responseData.code == 200) {
				setTseOwnerData(responseData.data);
				setIsTseOwnerManagerLoading(false);
			} else {
				setTseOwnerData([]);
				setIsTseOwnerManagerLoading(false);
			}
		} catch (error) {
			setIsTseOwnerManagerLoading(false);
			console.error("Error:", error);
		}
	};
	const getTattleColumnList = async () => {
		setIsColumnLoading(true);
		const requestBody = {
			app_token: process.env.REACT_APP_tattle_token,
			attribute_set_key: "crm",
			attribute_status: true,
		};
		try {
			const responseData = await fetchPostData(
				`${process.env.REACT_APP_tattle_api}/tattle/attributes`,
				requestBody
			);
			//console.log(responseData, "Tattle Attribute DATA");
			if (responseData.code == 200) {
				setTattleColumnData(responseData.data);
				setIsColumnLoading(false);
			} else {
				setTattleColumnData([]);
				setIsColumnLoading(false);
			}
		} catch (error) {
			setIsColumnLoading(false);
			console.error("Error:", error);
		}
	};

	useEffect(() => {
		//getCustomerData(currentPage);
		// This useEffect runs only after localStorage is processed
		if (localStorageProcessed) {
			getCustomerData(currentPage); // Call the API once
		}
	}, [
		localStorageProcessed, // This will trigger the effect after localStorage is processed
		search,
		sort,
		order,
		highlightedColumns,
		resetCounter,
		apiRun,
		filterItem,
		acManager,
		tseOwner,
		slManager,
		filterValue,
		inputValue,
	]);

	useEffect(() => {
		document.title = "Intranet | Accounts";
		//getUsers();
		getCrmFilterKeys();
		getProduct();
		getCustomerType();
		getPackage();
		// getCountries();
		// getApplication();
		// getSource();
		////getCrmSearchField();
		// getCancelReason();
		// getQuickFilterDataCount();
		// getAccountManager();
		// getSalesManager();
		// getTseOwnerManager();
		// getTattleColumnList();

		getAccountManager();
		getSalesManager();
		getTseOwnerManager();

		if (
			queryStringType != null &&
			queryStringType.length >= 1 &&
			queryStringCountryCode != null &&
			queryStringCountryCode.length >= 1
		) {
			getCountries();
		}

		//Getting Muvi userid to return login url as a parameter
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? decrypt(localStorage.getItem("encdata"), 0) : "";
		setMuviUserId(localdata && localdata.user_id);

		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				const reactDatePopup = document.querySelector(".rs-picker-popup-daterange");
				if (reactDatePopup) {
					// Update the popup style when it appears
					reactDatePopup.style.left = `${window.innerWidth - 390}px`;
					reactDatePopup.style.left = "203.2px";
					observer.disconnect(); // Stop observing once the element is found
					console.log(`${window.innerWidth - 390}px`);
				}
			});
		});
		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		return () => observer.disconnect();
	}, []);

	/**
	 * Searchbox code Start
	 */
	// Define the debounce function
	const customDebounce = (func, delay) => {
		let timer;
		return function (...args) {
			const context = this;
			if (timer) clearTimeout(timer);
			timer = setTimeout(() => {
				timer = null;
				func.apply(context, args);
			}, delay);
		};
	};
	// Define the search handler function
	const searchHandler = (searchTerm) => {
		setSearch(searchTerm);
	};

	// Memoize the debounced search handler using useCallback
	const debouncedSearchHandler = useCallback(
		customDebounce(searchHandler, 500), // Adjust the delay as needed
		[] // Empty dependency array ensures the callback is memoized only once
	);
	// Handle input change
	const handleInputChange = (event) => {
		const searchTerm = event.target.value; // Extract the value from the event
		setSearchTemp(searchTerm);
		debouncedSearchHandler(searchTerm); // Pass searchTerm to debouncedSearchHandler
		setCurrentPage(1);
		setSort("");
		setOrder("");
	};

	/**
	 * Searchbox code End
	 */

	/**
	 * QuickFilter code Start
	 */

	useEffect(() => {
		const getLocalStorageItem = (key) => {
			const myLocalStorageObjectString = window.localStorage.getItem("crm_filter");
			const crmFilterLocalStorage = JSON.parse(myLocalStorageObjectString);
			if (Array.isArray(crmFilterLocalStorage)) {
				for (const localStorage of crmFilterLocalStorage) {
					if (localStorage[key]) {
						return localStorage[key]; // Return the value if found
					}
				}
			}
			return [];
		};
		const customer_type = getLocalStorageItem("customer_type");
		// setLocalStorage(customer_type);

		if (customer_type.length > 0) {
			setHighlightedColumns((prevInputValue) => ({
				...prevInputValue,
				customer_type: customer_type,
			}));
			//advanced filter
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				customer_type: customer_type,
			}));
			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				customer_type: customer_type,
			}));
		}
		setQuickFilterColor(customer_type.length === 0);

		//advanced filter
		const product = getLocalStorageItem("product_key");
		if (product.length > 0) {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				product_key: product,
			}));
			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				product_key: product,
			}));
		}

		const packageData = getLocalStorageItem("package");
		if (packageData.length > 0) {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				package: packageData,
			}));
			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				package: packageData,
			}));
		}

		const created_date = getLocalStorageItem("created_date");
		if (created_date.length > 0) {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				created_date: created_date,
			}));
		}

		const created_date_temp = getLocalStorageItem("created_date_temp");
		if (created_date_temp) {
			const newDates = created_date_temp.map((dateStr) => new Date(dateStr));

			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				created_date: newDates,
			}));
		}
		// Parse query parameters for url form Home page
		const queryStringType = searchParams.get("type");
		if (queryStringType != null) {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				customer_type: [queryStringType],
			}));
			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				customer_type: [queryStringType],
			}));
		}
		// Set flag to true after localStorage is processed
		setLocalStorageProcessed(true);
	}, []);

	/**
	 * QuickFilter code End
	 */

	/**
	 * Reset Button Code Start
	 *Reset All filter state in TableHeader Component - tocall
	 */
	const resetHandler = () => {
		setHighlightedColumns({});
		setFilterItem({});
		setSearchTemp("");
		setSearch("");
		setResetCounter((prevCounter) => prevCounter + 1);
		setShowFilter(false);
		setAcManager([]);
		setTseOwner([]);
		setSlManager([]);
		setFilterColumn("");
		setFilterValue("");
		setFilterTempValue("");
		setInputValue({});
		setInputTemp({});

		window.localStorage.removeItem("crm_filter");

		if (
			queryStringType != null &&
			queryStringType.length >= 1 &&
			queryStringCountryCode != null &&
			queryStringCountryCode.length >= 1
		) {
			window.location.href = "/accounts/list";
		}

		// window.localStorage.removeItem("customer_type");
		// window.localStorage.removeItem("account_manager");
		// window.localStorage.removeItem("tse_owner");
		// window.localStorage.removeItem("sales_manager");
		// window.localStorage.removeItem("created_date");
		// window.localStorage.removeItem("package");
		// window.localStorage.removeItem("product_key");
		// window.localStorage.removeItem("created_date_temp");
		// setQuickFilterColor(true);
	};
	/**
	 * eset Button code End
	 */

	/**
	 * Extra Filter Start
	 */

	function showAdvFilter(divId) {
		if (divId == "adv_filter") {
			setShowFilter(!showFilter);
		}
	}
	const getReactSelectData = (formDataUpdated) => {
		setFilterItem({ ...filterItem, ...formDataUpdated });
		//console.log(301, filterItem);
	};
	// Define the debounce function

	const debounceOwn = (func, delay) => {
		let timer;
		return function (...args) {
			const context = this;
			if (timer) clearTimeout(timer);
			timer = setTimeout(() => {
				timer = null;
				func.apply(context, args);
			}, delay);
		};
	};
	// Define the search handler function
	const filterInputHandler = (name, value) => {
		//const { name, value } = target;
		if (name === "filter_value") {
			setFilterValue(value);
		}
	};

	// Memoize the debounced search handler using useCallback
	const debouncedFilterInputHandler = useCallback(debounceOwn(filterInputHandler, 500), []);

	//Custom Filter Start
	const searchColumnHandler = (value) => {
		if (inputDateList.includes(value)) {
			setIsDateFilter(true);
			setFilterTempDateValue(null);
			setFilterTempValue("");
		} else {
			setIsDateFilter(false);
			setFilterTempDateValue(null);
			setFilterTempValue("");
		}
		setFilterColumn(value);
	};
	const searchValueHandler = (event) => {
		debouncedFilterInputHandler("filter_value", event.target.value); // for instant submit
		setFilterTempValue(event.target.value);
		setCurrentPage(1);
		setSort("");
		setOrder("");
	};
	const handleApplyTimeSearch = (value) => {
		const formattedDates = value.map((date) => moment(date).format("YYYY-MM-DD"));
		let finalStartDate = formattedDates[0];
		let finalEndDate = formattedDates[1];

		setFilterTempValue(formattedDates);
		setFilterTempDateValue(value);
		setFilterValue(formattedDates); // for instant submit
		setCurrentPage(1);
		setSort("");
		setOrder("");
	};
	const handleCleanDateSearch = (value) => {
		setFilterTempValue("");
		setFilterTempDateValue(null);
		setFilterValue(""); // for instant submit
		setCurrentPage(1);
		setSort("");
		setOrder("");
	};
	const handleChangeDateSearch = (value) => {
		// `value` will contain the new date range selection
		if (!value) {
			setFilterTempValue("");
			setFilterTempDateValue(null);
			setFilterValue(""); // for instant submit
		} else {
			// Perform any other actions based on the new date range value
			const formattedDates = value.map((date) => moment(date).format("YYYY-MM-DD"));
			let finalStartDate = formattedDates[0];
			let finalEndDate = formattedDates[1];
			setFilterTempValue(formattedDates);
			setFilterTempDateValue(value);
			setFilterValue(formattedDates); // for instant submit
		}
		setCurrentPage(1);
		setSort("");
		setOrder("");
	};
	const searchDateValueHandler = (event) => {
		const dateVal = moment(event).format("YYYY-MM-DD");
		setFilterTempValue(dateVal);
	};

	const resetSearchFilter = () => {
		setFilterTempValue("");
		setFilterValue("");
	};
	const submitSetSearch = () => {
		setFilterValue(filterTempValue);
	};
	//Custom Filter End
	/**
	 *	@param - Advanced Filter
	 * @param {*} component - addClumnFilter
	 * @param {*} component - Date range field
	 */
	const handleSelectChange = (name) => (value) => {
		// Update crmFilter object
		const updatedCrmFilter = {
			...crmFilter,
			[name]: value,
		};

		// Retrieve existing data from localStorage
		const existingDataString = window.localStorage.getItem("crm_filter");
		let newCrmFilter = [];
		// Parse existing data if it exists, otherwise start with an empty array
		if (existingDataString) {
			try {
				newCrmFilter = JSON.parse(existingDataString);
			} catch (error) {
				console.error("Failed to parse existing data:", error);
				newCrmFilter = []; // Fallback to an empty array if parsing fails
			}
		}
		// Remove the existing filter with the same name if it exists
		newCrmFilter = newCrmFilter.filter((filter) => filter[name] === undefined);
		// Add the updated filter to the list
		newCrmFilter.push(updatedCrmFilter);
		// Convert the updated list back to a JSON string
		const updatedDataString = JSON.stringify(newCrmFilter);
		// Save the updated data back to localStorage
		window.localStorage.setItem("crm_filter", updatedDataString);
		// window.localStorage.setItem(name, JSON.stringify(value));

		setInputValue((prevInputValue) => ({
			...prevInputValue,
			[name]: value, // Update inputValue with the selected values
		}));
		setInputTemp((prevInputValue) => ({
			...prevInputValue,
			[name]: [...value], // Update inputValue with the selected values
		}));
		setCurrentPage(1);
		setSort("");
		setOrder("");
	};
	const handleApplyTime = (name) => (value) => {
		const formattedDates = value.map((date) => moment(date).format("YYYY-MM-DD"));
		let finalStartDate = formattedDates[0];
		let finalEndDate = formattedDates[1];

		// window.localStorage.setItem("created_date_temp", JSON.stringify(value));
		// window.localStorage.setItem(name, JSON.stringify(`${finalStartDate} ~ ${finalEndDate}`));

		setInputValue((prevInputValue) => ({
			...prevInputValue,
			[name]: `${finalStartDate} ~ ${finalEndDate}`, // Update inputValue with the selected values
		}));
		setInputTemp((prevInputValue) => ({
			...prevInputValue,
			[name]: value, // Update inputValue with the selected values
		}));
		setCurrentPage(1);
		setSort("");
		setOrder("");
	};
	const handleCleanDate = (name) => (value) => {
		// window.localStorage.removeItem(name);
		// window.localStorage.removeItem("created_date_temp");
		setInputValue((prevInputValue) => ({
			...prevInputValue,
			[name]: "", // Update inputValue with the selected values
		}));
		setInputTemp((prevInputValue) => ({
			...prevInputValue,
			[name]: null, // Update inputValue with the selected values
		}));
		setCurrentPage(1);
		setSort("");
		setOrder("");
	};
	const handleChangeDate = (name) => (value) => {
		// `value` will contain the new date range selection
		if (!value) {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				[name]: "", // Update inputValue with the selected values
			}));
			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				[name]: null, // Update inputValue with the selected values
			}));
		} else {
			// Perform any other actions based on the new date range value
			const formattedDates = value.map((date) => moment(date).format("YYYY-MM-DD"));
			let finalStartDate = formattedDates[0];
			let finalEndDate = formattedDates[1];
			// window.localStorage.setItem("created_date_temp", JSON.stringify(value));
			// window.localStorage.setItem(name, JSON.stringify(`${finalStartDate} ~ ${finalEndDate}`));
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				[name]: `${finalStartDate} ~ ${finalEndDate}`, // Update inputValue with the selected values
			}));
			setInputTemp((prevInputValue) => ({
				...prevInputValue,
				[name]: value, // Update inputValue with the selected values
			}));
		}
		setCurrentPage(1);
		setSort("");
		setOrder("");
	};

	const handleLessFilter = () => {
		setMoreFilter(false);
		setMoreButton(true);
	};
	const handleMoreFilter = () => {
		setMoreFilter(true);
		setMoreButton(false);
	};

	//Handle Column Hide and Show
	const handleToggleDropdown = (newState) => {
		setIsOpen(newState);
		if (newState) {
			getTattleColumnList();
		}
	};
	const handleColumnNameChage = (value, checked, event) => {
		//console.log(`Value: ${value}, Checked: ${checked}, Event:`, event);
		if (checked) {
			setSelectedColumnValues((prev) => [...prev, value]);
			//tattleColumnHideShow(value, "show");
		} else {
			setSelectedColumnValues((prev) => prev.filter((v) => v !== value));
			//tattleColumnHideShow(value, "hide");
		}
	};
	// Handle search input change
	const handleSearchChange = (value) => {
		setSearchQuery(value);
	};
	const handleCheckAll = (value, checked) => {
		if (checked) {
			setSelectedColumnValues(crmSearchFieldLists.map((item) => item.field));
		} else {
			setSelectedColumnValues([]);
		}
	};

	const handleColumnHideShowSubmitButton = () => {
		setIsOpen(false);
		// Determine checked and unchecked fields
		const checkedFields = selectedColumnValues;
		const uncheckedFields = previousSelectedColumns.filter((field) => !selectedColumnValues.includes(field));
		const newlyCheckedFields = selectedColumnValues.filter((field) => !previousSelectedColumns.includes(field));
		// console.log("Checked Fields:", newlyCheckedFields);
		// console.log("Unchecked Fields:", uncheckedFields);
		if (newlyCheckedFields.length >= 1) {
			tattleColumnHideShow(newlyCheckedFields, "show");
		}
		if (uncheckedFields.length >= 1) {
			tattleColumnHideShow(uncheckedFields, "hide");
		}
		setPreviousSelectedColumns(selectedColumnValues);
	};

	const tattleColumnHideShow = (columnName, statusType) => {
		let user_uuid = getCookie("muvi_useruuid");
		fetch(`${process.env.REACT_APP_tattle_api}/attribute/hide`, {
			method: "POST",
			body: JSON.stringify({
				app_token: process.env.REACT_APP_tattle_token,
				attribute_set_key: "crm",
				user_uuid: user_uuid ? user_uuid : "acfdd41f64c94f098ec605efc72271a8",
				attributes: columnName,
				status_type: statusType,
			}),
		})
			.then((res) => {
				return res.json();
			})
			.then((res) => {
				//setColumns(res.data);
				setReloadTattleList((prev) => prev + 1);
				getCustomerData(currentPage);
			})
			.catch((error) => {
				console.error("Fetch error:", error);
			});
	};

	function getFilter() {
		return (
			<div id="adv_filter" className={`adv_filter filter-wrap ${showFilter ? "show" : ""} `}>
				<div className="containerfull">
					<div className="row">
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Created Date</label>
								<DateRangePicker
									showOneCalendar
									ranges={predefinedRanges}
									onOk={handleApplyTime("created_date")}
									onClean={handleCleanDate("created_date")}
									onChange={handleChangeDate("created_date")}
									value={inputTemp.hasOwnProperty("created_date") ? inputTemp["created_date"] : null}
									block={true}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Application</label>
								<CheckPicker
									data={applicationData.map((item) => {
										return {
											label: item.name,
											value: item.name,
										};
									})}
									value={
										inputTemp.hasOwnProperty("application_name")
											? inputTemp["application_name"]
											: []
									}
									onChange={handleSelectChange("application_name")}
									style={{
										width: "100%",
										zIndex: 1050,
									}}
									block={true}
									placeholder="Select Application"
									onOpen={() => getApplication()}
									loading={isApplicationLoading}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Source</label>
								<CheckPicker
									data={sourceData.map((item) => {
										return {
											label: item.name,
											value: item.value,
										};
									})}
									value={inputTemp.hasOwnProperty("source") ? inputTemp["source"] : []}
									onChange={handleSelectChange("source")}
									style={{
										width: "100%",
										zIndex: 1050,
									}}
									block={true}
									placeholder="Select Source"
									onOpen={() => getSource()}
									loading={isSourceLoading}
								/>
							</div>
						</div>

						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Country</label>
								<CheckPicker
									data={countryData.map((item) => {
										return {
											label: item.nicename,
											value: item.iso,
										};
									})}
									value={inputTemp.hasOwnProperty("country_code") ? inputTemp["country_code"] : []}
									onChange={handleSelectChange("country_code")}
									style={{
										width: "100%",
										zIndex: 1050,
									}}
									block={true}
									placeholder="Select Country"
									onOpen={() => getCountries()}
									loading={isCountryLoading}
								/>
							</div>
						</div>
					</div>
					<br />
					<div className="row">
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Account Manager</label>
								<CheckPicker
									data={accountManagerData.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											imgUrl: item.attachment,
										};
									})}
									value={acManager}
									//onChange={setAcManager}
									onChange={(value) => (
										setAcManager(value), setCurrentPage(1), setSort(""), setOrder("")
									)}
									style={{ width: "100%", zIndex: 1050 }}
									block={true}
									placeholder="Select Account Manager"
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 10 }} />
											{label}
										</div>
									)}
									// renderValue={(value, items) => (
									// 	<div
									// 		style={{
									// 			display: "flex",
									// 			alignItems: "center",
									// 			flexWrap: "wrap",
									// 		}}
									// 	>
									// 		{items.map((item) => (
									// 			<div
									// 				key={item.value}
									// 				style={{
									// 					display: "flex",
									// 					alignItems: "center",
									// 					marginRight: 10,
									// 				}}
									// 			>
									// 				<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 5 }} />
									// 				<span>{item.label}</span>
									// 			</div>
									// 		))}
									// 	</div>
									// )}
									renderValue={(value, items) => <TagPickerImageValueRenderer items={items} />}
								// onOpen={() => getAccountManager()}
								// loading={isAccountManagerLoading}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Sales Manager</label>
								<CheckPicker
									data={salesManagerData.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											imgUrl: item.attachment,
										};
									})}
									value={slManager}
									//onChange={setSlManager}
									onChange={(value) => (
										setSlManager(value), setCurrentPage(1), setSort(""), setOrder("")
									)}
									style={{ width: "100%", zIndex: 1050 }}
									block={true}
									placeholder="Select Sales Manager"
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 10 }} />
											{label}
										</div>
									)}
									renderValue={(value, items) => <TagPickerImageValueRenderer items={items} />}
								// onOpen={() => getSalesManager()}
								// loading={isSalesManagerLoading}
								/>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">TSE Owner</label>
								<CheckPicker
									data={tseOwnerData.map((item) => {
										return {
											label: item.name,
											value: item.user_uuid,
											imgUrl: item.attachment,
										};
									})}
									value={tseOwner}
									//onChange={setTseOwner}
									onChange={(value) => (
										setTseOwner(value), setCurrentPage(1), setSort(""), setOrder("")
									)}
									style={{ width: "100%", zIndex: 1050 }}
									block={true}
									placeholder="Select TSE Owner"
									renderMenuItem={(label, item) => (
										<div style={{ display: "flex", alignItems: "center" }}>
											<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 10 }} />
											{label}
										</div>
									)}
									// renderValue={(value, items) => (
									// 	<div
									// 		style={{
									// 			display: "flex",
									// 			alignItems: "center",
									// 			flexWrap: "wrap",
									// 		}}
									// 	>
									// 		{items.map((item) => (
									// 			<div
									// 				key={item.value}
									// 				style={{
									// 					display: "flex",
									// 					alignItems: "center",
									// 					marginRight: 10,
									// 				}}
									// 			>
									// 				<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 5 }} />
									// 				<span>{item.label}</span>
									// 			</div>
									// 		))}
									// 	</div>
									// )}
									renderValue={(value, items) => <TagPickerImageValueRenderer items={items} />}
								// onOpen={() => getTseOwnerManager()}
								// loading={isTseOwnerLoading}
								/>
							</div>
						</div>

						<div className="col-md-3 col-lg-3">
							<div className="input-box">
								<label className="input-label">Cancelation Reason</label>
								<CheckPicker
									data={cancelReasonData.map((item) => {
										return {
											label: item.name,
											value: item.value,
										};
									})}
									value={
										inputTemp.hasOwnProperty("cancellation_reason")
											? inputTemp["cancellation_reason"]
											: []
									}
									onChange={handleSelectChange("cancellation_reason")}
									style={{
										width: "100%",
										zIndex: 1050,
									}}
									block={true}
									placeholder="Select Cancelation Reason"
									onOpen={() => getCancelReason()}
									loading={isCanceLoading}
									renderValue={(value, items) => <TagPickerValueRenderer items={items} />}
								/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="mx-auto">
							<a
								href="#"
								className={`float-right  ${moreButton ? "show" : "d-none"}`}
								onClick={handleMoreFilter}
								style={{ padding: "1rem .5rem", color: "#1675e0" }}
							>
								Advance Filter
							</a>
						</div>

						{/* <div className={`col-md-3 col-lg-3 ${moreButton ? "show" : "d-none"}`}>
							<div className="input-box">
								<label className="input-label">&nbsp;</label>
								<div className="more-btn btn-blue" onClick={handleMoreFilter} style={{ marginTop: "0px" }}>
									More Filter
								</div>
							</div>
						</div> */}
					</div>

					<div className={`row ${moreFilter ? "show" : "d-none"}`}>
						<div className="col-md-3 col-lg-3">
							<div className="input-box tag-box">
								<label className="input-label">Column Name</label>
								<div className="w-100">
									<div className="text_filter dropdown bootstrap-select show-tick productselect bs3">
										<SelectPicker
											data={
												tattleColumnData.map((item) => ({
													label: item.headerName,
													value: item.field,
												})) || []
											}
											// val={
											//   filterItem.department_name &&
											//   filterItem.department_name
											// }
											select={true}
											style={{ width: "100%", zIndex: 1100 }}
											block={true}
											onChange={(evt) => searchColumnHandler(evt)}
											field_name="department_name"
											onOpen={() => getTattleColumnList()}
											loading={isColumnLoading}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-3 col-lg-3">
							<div className="input-box tag-box">
								<label className="input-label">Value</label>
								<div className="w-100">
									<div
										className={`text_filter dropdown bootstrap-select show-tick productselect bs3 search_value_search ${!isDateFilter ? "show" : "d-none"
											}`}
									>
										<div className="remove-search">
											{filterTempValue.length >= 1 ? (
												<BiX style={{ fontSize: "20px" }} onClick={resetSearchFilter} />
											) : (
												""
											)}
										</div>
										<input
											type="text"
											name="filter_value"
											onChange={searchValueHandler}
											placeholder="Search by value"
											id=""
											value={filterTempValue || ""}
											className="form-control show-more-filter-text"
											autoComplete="off"
										/>
									</div>
									<div
										className={`text_filter dropdown bootstrap-select show-tick productselect bs3 search_value_search ${isDateFilter ? "show" : "d-none"
											}`}
									>
										<DateRangePicker
											showOneCalendar
											ranges={predefinedRanges}
											onOk={handleApplyTimeSearch}
											onClean={handleCleanDateSearch}
											onChange={handleChangeDateSearch}
											value={filterTempDateValue || null}
											block={true}
										/>

										{/* <DatePicker
											name="filter_value"
											value={filterTempValue || ""}
											onChange={searchDateValueHandler}
											className="form-control1"
											block={true}
										/> */}
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-3 col-lg-3 ">
							<label htmlFor="">&nbsp;&nbsp;</label>
							<div className="more_filter-ui-less">
								{/* <div class="more-btn btn-blue more_filter-ui-search" onClick={submitSetSearch}>
									Submit
								</div> */}
								<div className="more_filter-ui-less" style={{ marginTop: "10px" }}>
									<a
										href="#"
										onClick={handleLessFilter}
										style={{ padding: "1rem .5rem", color: "#1675e0" }}
									>
										Less Filter
									</a>

									{/* <div className="more-btn btn-blue more_filter-ui-search" onClick={handleLessFilter}>
										Less Filter
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	/**
	 * Extra Filter End
	 */

	/* customer Map Start */
	const getCustomerMapData = async () => {
		const topology = await fetch("https://code.highcharts.com/mapdata/custom/world.topo.json").then((response) =>
			response.json()
		);
		Highcharts.getJSON(process.env.REACT_APP_CRM + `/crm/get-worlwide-customer-data`, function (data) {
			// Create the chart
			Highcharts.mapChart("worldwide_customer_chart", {
				chart: {
					map: topology,
					height: 750,
					mapNavigation: {
						enabled: false,
					},
				},

				exporting: {
					buttons: {
						contextButton: {
							enabled: false,
						},
					},
				},
				title: {
					text: "", // data.last_updated,
					align: "center",
					verticalAlign: "bottom",
					y: 10,
					style: {
						fontSize: "12 px",
						color: "rgb(102, 102, 102)",
					},
				},

				subtitle: {
					text: "",
				},

				credits: {
					enabled: false,
				},

				mapNavigation: {
					enabled: true,
					buttonOptions: {
						verticalAlign: "bottom",
					},
				},

				colorAxis: {
					min: 1,
					type: "logarithmic",
					minColor: "#EEEEFF",
					maxColor: "rgb(25, 103, 210)",
					stops: [
						[0, "#EFEFFF"],
						[0.67, "#4444FF"],
						[1, "#000022"],
					],
				},
				tooltip: {
					formatter: function () {
						return this.point.name + ":" + this.point.value;
					},
				},
				series: [
					{
						data: data.response,
						states: {
							hover: {
								color: "#0CB9F2",
							},
						},
						dataLabels: {
							enabled: false,
							format: "{point.name}",
						},
						// Add a click event to each country
						// point: {
						// 	events: {
						// 		click: function (event) {
						// 			getCountries();
						// 			const clickedCountry = event.point.name; // Get the clicked state's name
						// 			const url = new URL(window.location.href);
						// 			url.searchParams.set("country", clickedCountry);
						// 			window.history.pushState({}, "", url.toString());
						// 			//console.log(end_year_month);
						// 			//alert(`Country: ${this.name}, Value: ${this.value}`);
						// 			setInputTemp((prevInputValue) => ({
						// 				...prevInputValue,
						// 				country_code: [this.properties["hc-a2"]],
						// 				customer_type: ["customer"],
						// 				//first_subscription_date: [new Date(newStartDate), new Date(newEndDate)],
						// 			}));
						// 			setInputValue((prevInputValue) => ({
						// 				...prevInputValue,
						// 				country_code: [this.properties["hc-a2"]],
						// 				customer_type: ["customer"],
						// 				//first_subscription_date: [new Date(newStartDate), new Date(newEndDate)],
						// 			}));
						// 			setOpenWithHeader(false);
						// 		},
						// 	},
						// },
						point: {
							events: {
								click: function (event) {
									getCountries();

									// Extract the country code from the point's properties
									const clickedCountryCode = this.properties["hc-a2"]; // Assuming "hc-a2" contains the country code
									const url = new URL(window.location.href);

									// Set the country code in the URL search params
									url.searchParams.set("country", clickedCountryCode);
									window.history.pushState({}, "", url.toString());

									// Update state with the country code and other values
									setInputTemp((prevInputValue) => ({
										...prevInputValue,
										country_code: [clickedCountryCode],
										customer_type: ["customer"],
									}));
									setInputValue((prevInputValue) => ({
										...prevInputValue,
										country_code: [clickedCountryCode],
										customer_type: ["customer"],
									}));

									// Close the modal or perform other necessary actions
									setOpenWithHeader(false);
								},
							},
						},

					},
				],
			});
		});
	};
	/* customer Map End */

	useEffect(() => {
		if (customerLists.length > 0) {
			const firstCustomer = customerLists[0];
			firstCustomerRef.current = firstCustomer; 
		} else {
			firstCustomerRef.current = null; 
		}
	}, [customerLists]);

	const handleOkClick = async () => {
		try {
			setEmailModalOpen(false); 
			await getCustomerData(currentPage);

			if (appToken) {
				window.location.href = `/account/${appToken}`;
			} else {
				console.warn("No customer found for redirection.");
			}
		} catch (error) {
			console.error("Error in handleOkClick:", error);
		}
	};

	const mailTriggerPopup = async (appToken) => {
		try {
			setModalOpen(false);
			setAppToken(appToken);
			const emailPayload = {
				username: formData.customerName,
				email: formData.emailId,
				login_url: process.env.REACT_APP_LOGIN_URL,
				password: formData.password,
			};

			const response = await fetch(`${apiUrl}/CrmRest/FreeTrialSuccess`, {
				method: "POST",
				body: JSON.stringify(emailPayload),
			});

			const successResult = await response.json();

			if (successResult && successResult.code === 200) {
				setEmailModalOpen(true);
			} else {
				console.error("Error in mail trigger popup:", successResult);
			}
		} catch (error) {
			console.error("Error triggering mail popup:", error);
		}
	};

	const [isCopied, setIsCopied] = useState(false);

	const handleCopyText = () => {
		const details = `Login URL: ${process.env.REACT_APP_LOGIN_URL}\nEmail: ${formData.emailId}\nPassword: ${formData.password}`;
		navigator.clipboard.writeText(details).then(() => {
			setIsCopied(true);
			setTimeout(() => setIsCopied(false), 2000);
		});
	};

	function CheckMark({ isVisible }) {
		return (
			<svg
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				style={{
					transition: "all 300ms ease-in-out", 
				}}
			>
				<path
					d="M13.25 4.75L6 12L2.75 8.75"
					style={{
						strokeDasharray: 50, 
						strokeDashoffset: isVisible ? 0 : 50,
						transition: "all 300ms ease-in-out", 
					}}
				/>
			</svg>
		);
	}

	return (
		<div>
			<Header brecum_name="CRM" brecum_page="Accounts" />
			<ToastContainer />
			<div className="right_col">
				<div className="customer-wrap">
					<div className="page-top" style={{ padding: "16px 0 5px" }}>
						<div className="containerfull">
							<div className="row align-items-center">
								<div className="col-md-12">
									<div>
										<div className="d-flex justify-content-between align-items-center">
											<div className="d-flex align-items-center title">
												<h2>Accounts</h2>
											</div>
											<Dropdown
												title="Actions"
												className="custom-action-dropdown"
												placement="bottomEnd"
											>
												<Dropdown.Item onClick={() => setModalOpen(true)}>
													Create Trial Account
												</Dropdown.Item>
												<Dropdown.Item onClick={handleTestCredentialClick}>
													End User Test Credential
												</Dropdown.Item>
											</Dropdown>
										</div>
									</div>
								</div>
								{/* Modal */}
								<ReactModal
									isOpen={modalOpen}
									onRequestClose={() => {
										setModalOpen(false);
										setFormData({
											customerName: "",
											companyName: "",
											phoneNumber: "",
											emailId: "",
											password: "",
											products: [],
										});
									}}
									className="trial-account-modal p-4 rounded shadow bg-white"
									style={{
										content: {
											width: "90%", // Start with a flexible width for smaller screens
											maxWidth: "500px", // Maintain the original maximum width
											margin: "auto",
											borderRadius: "8px",
											fontFamily: "Arial, sans-serif",
											height: "auto",
											// maxHeight: '90vh', // Ensure the modal doesn’t exceed 90% of viewport height
											overflow: "hidden",
											display: "flex",
											flexDirection: "column",
											justifyContent: "center",
											alignItems: "center",
											position: "absolute",
											top: "50%",
											left: "50%",
											transform: "translate(-50%, -50%)",
											padding: "1rem", // Add some padding for smaller devices
											boxSizing: "border-box", // Ensure padding does not overflow the modal
											overflowY: "auto",
											scrollbarWidth: "none",
										},
										overlay: {
											backgroundColor: "rgba(0, 0, 0, 0.5)",
											zIndex: 1100,
										},
									}}
									ariaHideApp={false} // Disable ARIA app element warnings (only for dev)
								>
									{/* <h2>Create a Trial Account</h2> */}
									<CreateTrialForm
										mailTriggerPopup={mailTriggerPopup}
										formData={formData}
										setFormData={setFormData}
										apiUrl={apiUrl}
										setApiUrl={setApiUrl}
										productOptions={productOptions}
										closeModal={() => {
											setModalOpen(false);
											setFormData({
												customerName: "",
												companyName: "",
												phoneNumber: "",
												emailId: "",
												password: "",
												products: [],
											});
										}}
									/>
								</ReactModal>
								<ReactModal
									isOpen={testCredentialModalOpen}
									onRequestClose={() => setTestCredentialModalOpen(false)}
									style={{
										content: {
											width: "400px",
											height: "300px",
											margin: "auto",
											padding: "20px",
											borderRadius: "10px",
											boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
											border: "1px solid #ccc",
											overflow: "hidden",
											display: "flex",
											flexDirection: "column",
											justifyContent: "center",
											alignItems: "center",
										},
										overlay: {
											backgroundColor: "rgba(0, 0, 0, 0.6)",
											zIndex: 1000,
										},
									}}
								>
									<button
										onClick={() => setTestCredentialModalOpen(false)}
										style={{
											position: "absolute",
											top: "10px",
											right: "10px",
											background: "transparent",
											border: "none",
											fontSize: "18px",
											cursor: "pointer",
										}}
									>
										&times;
									</button>
									<h2
										style={{
											marginBottom: "20px",
											fontSize: "20px",
											textAlign: "center",
										}}
									>
										End User Test Credential
									</h2>
									<table style={{ width: "100%", borderCollapse: "collapse" }}>
										<tbody>
											<tr>
												<td
													style={{
														fontWeight: "bold",
														textAlign: "left",
														padding: "10px",
													}}
												>
													Email
												</td>
												<td style={{ textAlign: "left", padding: "10px" }}>
													{testCredentials.email}
												</td>
											</tr>
											<tr>
												<td
													style={{
														fontWeight: "bold",
														textAlign: "left",
														padding: "10px",
													}}
												>
													Password
												</td>
												<td style={{ textAlign: "left", padding: "10px" }}>
													{testCredentials.password}
												</td>
											</tr>
										</tbody>
									</table>

									<button
										onClick={handleCopy}
										style={{
											marginTop: "20px",
											padding: "10px 20px",
											backgroundColor: "#0cb9f2",
											color: "#fff",
											border: "none",
											borderRadius: "5px",
											cursor: "pointer",
											display: "flex",
											alignItems: "center",
											gap: "8px",
											fontSize: "16px",
										}}
									>
										{copied ? (
											<CheckMark isVisible={true} />
										) : (
											"Copy Credentials"
										)}
									</button>
								</ReactModal>
							</div>
							<div className="row mt-5">
								<div className="col-md-6">
									<div class="row" style={{ margin: "1rem .5rem" }}>
										<div class="col-md-4 col-lg-4">
											<div class="input-box">
												<CheckPicker
													data={
														Array.isArray(productData)
															? productData.map((item) => {
																return {
																	label: item.product_name,
																	value: item.product_key,
																};
															})
															: []
													}
													value={
														inputTemp.hasOwnProperty("product_key")
															? inputTemp["product_key"]
															: []
													}
													onChange={handleSelectChange("product_key")}
													style={{
														width: "100%",
														zIndex: 1050,
													}}
													block={true}
													placeholder="Select Product"
												// onOpen={() => getProduct()}
												// loading={isProductLoading}
												/>
											</div>
										</div>
										<div class="col-md-4 col-lg-4">
											<div class="input-box">
												<CheckPicker
													data={customerTypeData.map((item) => {
														return {
															label: item.value,
															value: item.id,
														};
													})}
													value={
														inputTemp.hasOwnProperty("customer_type")
															? inputTemp["customer_type"]
															: []
													}
													onChange={handleSelectChange("customer_type")}
													style={{
														width: "100%",
														zIndex: 1050,
													}}
													block={true}
													placeholder="Select Customer Type"
												// onOpen={() => getCustomerType()}
												// loading={isCustomerLoading}
												/>
											</div>
										</div>
										<div class="col-md-4 col-lg-4">
											<div class="input-box">
												<CheckPicker
													data={packageData.map((item) => {
														return {
															label: item.name,
															value: item.value,
														};
													})}
													value={
														inputTemp.hasOwnProperty("package") ? inputTemp["package"] : []
													}
													onChange={handleSelectChange("package")}
													style={{
														width: "100%",
														zIndex: 1050,
													}}
													block={true}
													placeholder="Select Package"

												// onOpen={() => getPackage()}
												// loading={isPackageLoading}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="d-flex" style={{ marginTop: "10px", marginRight: "1rem" }}>
										<div className="lct-form-group" style={{ height: "37px" }}>
											<button
												type="submit"
												style={{
													background: "#fff",
													padding: "8px 3px 8px 11px",
												}}
											>
												<BsSearch />
											</button>
											<input
												placeholder="Search"
												type="text"
												class="form-control input-f"
												name="search"
												id="search"
												autoComplete="off"
												onChange={handleInputChange}
												value={searchTemp}
												style={{
													padding: " 0 0 0 5px",
													height: "35px",
													borderRadius: "6px",
												}}
											/>
										</div>
										<div
											id="toggle-btnf"
											style={{ height: "37px" }}
											class={"toogle-btn" + (showFilter ? " collapse-state" : "")}
											onClick={() => showAdvFilter("adv_filter")}
										>
											<svg
												width="20"
												height="17"
												viewBox="0 0 20 17"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M7.83333 12.5H11.1667V11.3571H7.83333V12.5ZM4.5 9.07143H14.5V7.92857H4.5V9.07143ZM2 4.5V5.64286H17V4.5H2Z"
													fill="#303049"
												></path>
											</svg>
										</div>

										<div class="toogle-btn" style={{ height: "37px", padding: "7px 4px" }}>
											<Dropdown
												// renderToggle={renderIconButton}
												renderToggle={({ onClick }) => (
													<Button
														onClick={() => handleToggleDropdown(!isOpen)}
														appearance="default"
														style={{ background: "#fff" }}
													>
														<RxMixerHorizontal />
													</Button>
												)}
												placement="leftStart"
												// onToggle={handleToggleDropdown}
												open={isOpen}
											>
												<div className="" style={{ margin: "0px 10px" }}>
													{/* <Input
														placeholder="Search..."
														value={searchQuery}
														onChange={handleSearchChange}
														style={{ marginBottom: 10 }}
													/> */}
													<InputGroup inside>
														<Input
															placeholder="Search..."
															value={searchQuery}
															onChange={handleSearchChange}
														/>
														<InputGroup.Addon
															style={{ fontSize: "17px", padding: "2px 8px" }}
														>
															<BiSearchAlt2 />
														</InputGroup.Addon>
													</InputGroup>
												</div>
												<CheckboxGroup
													name="checkbox-group"
													style={{
														width: "220px",
														padding: ".15rem 1rem",
														height: "190px",
														overflow: "auto",
													}}
													value={selectedColumnValues}
													disabled={isColumnLoading}
												>
													{isColumnLoading && <Loader backdrop vertical size="sm" />}

													{crmSearchFieldLists.map((item) => (
														<Checkbox value={item.field} onChange={handleColumnNameChage}>
															{item.headerName}
														</Checkbox>
													))}
												</CheckboxGroup>
												<Dropdown.Separator />
												<div style={footerStyles}>
													{/* <Checkbox
														indeterminate={
															selectedColumnValues.length > 0 &&
															selectedColumnValues.length < crmSearchFieldLists.length
														}
														checked={selectedColumnValues.length === crmSearchFieldLists.length}
														onChange={handleCheckAll}
													>
														Check all
													</Checkbox> */}
													<Button
														style={footerButtonStyle}
														appearance="primary"
														size="sm"
														onClick={() => handleToggleDropdown(!isOpen)}
														className="btn btn-blue"
													>
														Cancel
													</Button>
													<Button
														style={footerButtonStyleRight}
														appearance="primary"
														size="sm"
														onClick={handleColumnHideShowSubmitButton}
													>
														Apply
													</Button>
												</div>
											</Dropdown>
										</div>

										<div class="toogle-btn" onClick={resetHandler} style={{ height: "37px" }}>
											<span>
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0.666748 2.66666V6.66666H4.66675"
														stroke="#202223"
														stroke-opacity="0.5"
														stroke-width="1.33"
														stroke-linecap="round"
														stroke-linejoin="round"
													></path>
													<path
														d="M2.34008 10C2.77234 11.2269 3.59164 12.2801 4.67452 13.0009C5.7574 13.7217 7.0452 14.0711 8.34389 13.9963C9.64258 13.9216 10.8818 13.4268 11.8748 12.5865C12.8679 11.7462 13.5609 10.606 13.8496 9.33758C14.1382 8.06917 14.0068 6.74131 13.4752 5.55407C12.9435 4.36684 12.0404 3.38454 10.902 2.75518C9.76351 2.12583 8.45135 1.88352 7.1632 2.06475C5.87505 2.24599 4.68069 2.84095 3.76008 3.76001L0.666748 6.66667"
														stroke="#202223"
														stroke-opacity="0.5"
														stroke-width="1.33"
														stroke-linecap="round"
														stroke-linejoin="round"
													></path>
												</svg>
											</span>
										</div>

										<div
											class="toogle-btn"
											onClick={() => setOpenWithHeader(true)}
											style={{ height: "37px" }}
										>
											<span>
												<svg
													stroke="currentColor"
													fill="none"
													stroke-width="2"
													viewBox="0 0 24 24"
													stroke-linecap="round"
													stroke-linejoin="round"
													height="16"
													width="16"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
													<circle cx="12" cy="10" r="3"></circle>
												</svg>
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					{showFilter ? getFilter() : ""}

					{/* Customer List */}
					<div class="body-content">
						<div class="table-wrap" style={{ padding: "5px", minHeight: "60vh" }}>
							<table style={{ tableLayout: "fixed" }}>
								<TableHead
									data={columnsData}
									sendDataToParent={receiveDataFromChild}
									resetFilter={resetCounter}
									productData={productData}
									customerTypeData={customerTypeData}
									packageData={packageData}
								/>
								<TableList
									data={customerLists}
									loading={loading}
									totalCount={totalCount}
									columndata={columnsData}
									setApiRun={setApiRun}
									currentPage={currentPage}
									isLive={false}
									productData={productData}
									crmUserFilterKeyLists={crmUserFilterKeyLists}
									muviUserId={muviUserId}
									accountManagerData={accountManagerData}
									salesManagerData={salesManagerData}
									tseOwnerData={tseOwnerData}
								/>
							</table>
						</div>
					</div>

					{/* Pagination */}
					{totalCount > 0 ? (
						<div
							class="d-flex mu-pagination justify-content-between align-items-center"
							aria-label="Page navigation example"
						>
							<div class="txt-dark">
								Showing {offSet + 1 + " - " + (offSet + perPage)} of {totalCount}
							</div>
							<div class="mu-pagination">
								<Pagination
									activePage={currentPage}
									itemsCountPerPage={20}
									totalItemsCount={totalCount}
									pageRangeDisplayed={5}
									itemClass="page-item"
									linkClass="page-link"
									onChange={handlePageChange}
								/>
							</div>
						</div>
					) : (
						""
					)}
				</div>
			</div>
			<Drawer
				open={openWithHeader}
				onClose={() => setOpenWithHeader(false)}
				onOpen={() => getCustomerMapData()}
				size="md"
			>
				<Drawer.Header>
					<Drawer.Title>Customer Map</Drawer.Title>
					<Drawer.Actions></Drawer.Actions>
				</Drawer.Header>
				<Drawer.Body>
					<div id="worldwide_customer_chart" className="product-graph"></div>
				</Drawer.Body>
			</Drawer>
			<ReactModal
				isOpen={emailModalOpen}
				onRequestClose={() => setEmailModalOpen(false)}
				className="trial-account-modal p-4 rounded shadow bg-white"
				style={{
					content: {
						width: '90%',
						maxWidth: '500px',
						margin: 'auto',
						borderRadius: '8px',
						fontFamily: 'Arial, sans-serif',
						height: '400px',
						overflow: 'hidden',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						padding: '1.5rem',
						boxSizing: 'border-box',
					},
					overlay: {
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
						zIndex: 1100,
					},
				}}
				ariaHideApp={false}
			>
				<div style={{ textAlign: 'center' }}>
					<div
						style={{
							width: '50px',
							height: '50px',
							borderRadius: '50%',
							backgroundColor: '#e8f5e9',
							margin: '0 auto',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							fill="#4caf50"
							viewBox="0 0 24 24"
						>
							<path d="M9 16.2l-3.5-3.5 1.41-1.41L9 13.38l7.59-7.59L18 7.8l-9 9z" />
						</svg>
					</div>
					<h2 style={{ margin: '1rem 0 0.5rem', color: '#333' }}>Account Details</h2>
					<p style={{ marginBottom: '1rem', color: '#555' }}>
						Below are your account details:
					</p>
					<div
						style={{
							textAlign: 'left',
							backgroundColor: isCopied ? '#d4edda' : '#f9f9f9', // Change color when copied
							padding: '1rem',
							borderRadius: '8px',
							width: '100%',
							maxWidth: '450px',
							boxSizing: 'border-box',
							fontFamily: 'poppins',
							fontSize: '1.4rem',
							cursor: 'pointer',
							transition: 'background-color 0.3s ease, border-color 0.3s ease',
							border: isCopied ? '2px solid #155724' : 'none', // Optional border for highlighting
						}}
						onClick={handleCopyText}
					>
						<div>
							<strong>Login URL:</strong> {process.env.REACT_APP_LOGIN_URL}
						</div>
						<div>
							<strong>Email:</strong> {formData.emailId}
						</div>
						<div>
							<strong>Password:</strong> {formData.password}
						</div>
					</div>
					<button
						onClick={handleOkClick}
						style={{
							marginTop: '1.5rem',
							padding: '0.5rem 1.5rem',
							backgroundColor: '#52b7ed',
							color: '#fff',
							border: 'none',
							borderRadius: '4px',
							cursor: 'pointer',
						}}
					>
						OKAY
					</button>
				</div>
			</ReactModal>
		</div>
	);
};

export default withRouter(NewCustomerList);



// WEBPACK FOOTER //
// ./src/components/crm/customer/NewCustomerList.js